var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 168H43.6364V93.8186L0 61.0913V154.909C0 162.153 5.86909 168 13.0909 168Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.364 168H178.909C186.153 168 192 162.131 192 154.909V61.0913L148.364 93.8186",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.364 37.0909V93.8182L192 61.0909V43.6364C192 27.4473 173.52 18.2182 160.582 27.9273",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6362 93.8186V37.0913L95.9999 76.364L148.363 37.0913V93.8186L95.9999 133.091",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 43.6364V61.0909L43.6364 93.8182V37.0909L31.4182 27.9273C18.4582 18.2182 0 27.4473 0 43.6364Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 144,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.2177fed7c7391e8e3cdebf7c09003b7c.svg";
export { ForwardRef as ReactComponent };